module.exports = __webpack_public_path__ + "static/media/16.a23288b4.jpg";